import { SelectorLocation } from '@candu-ai/placement/types';

import {
  SET_COMPONENTS_SEARCH,
  SET_FORCE_PLACEMENTS_TAB,
  SET_PALETTE_APPEARANCE,
  SET_PALETTE_LAYERS_HIDDEN,
  SET_PALETTE_TAB,
  SET_PLACEMENT_MODE,
  SET_PREVIEW_SELECTOR,
  SET_PREVIEW_SELECTOR_LOCATION,
  SET_TOOLBOX_TAB,
} from './constants';
import { PaletteAppearance } from './reducer';

export const setComponentsSearch = (componentsSearch?: string) => ({
  type: SET_COMPONENTS_SEARCH,
  componentsSearch,
});

export const setPaletteAppearence = (paletteAppearance: PaletteAppearance) => ({
  type: SET_PALETTE_APPEARANCE,
  paletteAppearance,
});

export const setPaletteLayersHidden = (hiddenLayers?: boolean) => ({
  type: SET_PALETTE_LAYERS_HIDDEN,
  hiddenLayers: hiddenLayers ?? false,
});

export const setPaletteTab = (paletteTab?: string) => ({
  type: SET_PALETTE_TAB,
  paletteTab,
});

export const setToolboxTab = (toolboxTab?: string) => ({
  type: SET_TOOLBOX_TAB,
  toolboxTab,
});

export const setPlacementMode = (placementMode: boolean) => ({
  type: SET_PLACEMENT_MODE,
  placementMode,
});

export const setPreviewSelector = (previewSelector?: string) => ({
  type: SET_PREVIEW_SELECTOR,
  previewSelector,
});

export const setPreviewSelectorLocation = (previewSelectorLocation?: SelectorLocation) => ({
  type: SET_PREVIEW_SELECTOR_LOCATION,
  previewSelectorLocation,
});

export const setForcePlacementsTab = (forcePlacementsTab: boolean) => ({
  type: SET_FORCE_PLACEMENTS_TAB,
  forcePlacementsTab,
});
